import { mutateWorksOrderGroup } from "@/api/worksOrderGroup/useWorksOrderGroup";
import { COMMON_TEXT } from "@/constants/text";
import { useModal } from "@/context/ModalStackManager";
import { customNotification } from "@/utils/notificationShow";
import {
  DefaultApiWorksOrderGroupOrderSequencePutRequest,
  WorksOrderGroupOrderSequencePutRequest,
} from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useWorksOrderHandler = () => {
  const queryClient = useQueryClient();
  const { closeModal } = useModal();

  const { mutate: orderWorks } = useMutation(
    (params: DefaultApiWorksOrderGroupOrderSequencePutRequest) =>
      mutateWorksOrderGroup.order(params).mutationFn(undefined),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([]);
        customNotification.success({
          message: COMMON_TEXT.NOTIFICATION.ORDER_SUCCESS,
        });
        closeModal();
      },
      onError: (error: any) => {
        customNotification.error({
          message:
            error?.response?.data?.message ??
            COMMON_TEXT.NOTIFICATION.ORDER_FAIL,
        });
      },
    }
  );

  const onSubmit = ({
    worksOrderGroupOrderSequencePutRequest,
  }: {
    worksOrderGroupOrderSequencePutRequest: WorksOrderGroupOrderSequencePutRequest;
  }) => {
    orderWorks({ worksOrderGroupOrderSequencePutRequest });
  };

  return {
    onSubmit,
  };
};
